<template>
	<div class="detail_container">
		<div class="dcont_bg"></div>
		<div class="dcont_wrap">
			<div class="dcont_card">
				<div class="tit">
					<div>{{ consultationsInfo.hospital }}</div>
				</div>
				<div class="cont cont_line">
					<div class="cont_item">
						<div class="label">患者姓名</div>
						<div class="value">{{ consultationsInfo.name }}</div>
					</div>
					<div class="cont_item">
						<div class="label">患者性别</div>
						<div class="value">{{ consultationsInfo.sex }}</div>
					</div>
					<div class="cont_item">
						<div class="label">患者年龄</div>
						<div class="value">{{ consultationsInfo.age }}</div>
					</div>
					<!-- 			<view class="cont_item">
						<view class="label">联系电话</view>
						<view class="value">{{consultationsInfo.mobile}}</view>
					</view> -->
					<!-- 			<view class="cont_item">
						<view class="label">就诊科室名称</view>
						<view class="value">{{consultationsInfo.type}}</view>
					</view> -->
					<div class="cont_item">
						<div class="label">就诊日期</div>
						<div class="value">{{ consultationsInfo.time }}</div>
					</div>
					<!-- 					<view class="cont_item">
						<view class="label">主诊医生姓名</view>
						<view class="value">{{consultationsInfo.doctor}}</view>
					</view> -->
					<div class="cont_item">
						<div class="label">临床诊断</div>
						<div class="value">{{ consultationsInfo.diagnose }}</div>
					</div>
					<!-- 			<view class="cont_item">
						<view class="label">次诊断名称</view>
						<view class="value">{{consultationsInfo.secondDiagnose}}</view>
					</view> -->
					<!-- 				<view class="cont_item">
						<view class="label">医疗机构代码</view>
						<view class="value">{{consultationsInfo.hospitalCode}}</view>
					</view> -->
					<div class="cont_item">
						<div class="label">主诉</div>
						<div class="value">{{ consultationsInfo.zhuSu }}</div>
					</div>
					<div class="cont_item" style="align-items: flex-start;">
						<div class="label">病史</div>
						<div class="wValue">{{ consultationsInfo.bingShiXBS }}</div>
					</div>
					<div class="cont_item" style="align-items: flex-start;">
						<div class="label">处理意见</div>
						<div class="wValue">{{ consultationsInfo.chuLiYJ }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'consultationDetail',
  data () {
    return {
      navIndex: '',
      consultationsInfo: {},
      resList: []
    }
  },
  created () {
    this.getInfo()
  },
  methods: {
    // 获取详情信息
    getInfo () {
      let that = this
      let data = this.$route.params
      let detail = {
        hospital: data.yiLiaoJGMC,
        name: data.bingRenXM,
        sex: data.xingBieMC,
        age: data.nianLing + data.nianLingDW,
        ageUnit: data.nianLingDW,
        time: data.jiuZhenRQ,
        diagnose: data.linChuangZD,
        bingShiQT: data.bingShiQT,
        bingShiXBS: data.bingShiXBS,
        zhuSu: data.zhuSu,
        chuLiYJ: data.chuLiYJ
      }
      that.consultationsInfo = detail
    }
  },
  onReady () {
    /* uni.setNavigationBarColor({
      frontColor: '#ffffff', // 前景颜色值，包括按钮、标题、状态栏的颜色，仅支持 #ffffff 和 #000000
      backgroundColor: '#4BCBC3' // 背景颜色值，有效值为十六进制颜色
    }) */
  }
}
</script>

<style>
page {
	/* background-color: red; */
}
</style>
<style lang="scss" scoped>
.detail_container {
	width: 100%;
	padding-bottom: 1px;
	.dcont_bg {
		position: absolute;
		z-index: 0;
		width: 100%;
		height: 130px;
		background-color: #4bcbc3;
	}
	.dcont_wrap {
		position: relative;
		z-index: 2;
		margin: 0 12px;
		top: 12px;
	}
}
.dcont_card {
	background-color: #fff;
	border-radius: 12px;
	padding: 0 16px;
	margin-bottom: 16px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	.tit {
		font-size: 16px;
		color: #303133;
		padding: 16px 0;
	}
	.text_center {
		text-align: center;
	}
	.cont {
		width: 100%;
		padding-bottom: 1px;
		.cont_item {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 14px;
			margin: 16px 0;
			.label {
				color: #919398;
			}
			.value {
				width: 160px;
				text-align: right;
				color: #303133;
				// text-overflow: ellipsis;
				// overflow: hidden;
				// white-space: nowrap;
			}
			.wValue {
				width: 260px;
				// margin-right: 32rpx;
				text-align: left;
				color: #303133;
				text-indent: 2em;
			}
		}
		.card_info {
			font-size: 14px;
			color: #606266;
			padding: 16px 0;
		}
	}
	.cont_line {
		border-top: solid 1rpx #e5e7ed;
	}
}
.sub_card {
	border-radius: 8px;
	border: 1rpx solid #e5e7ed;
	overflow: hidden;
	margin-bottom: 16px;
	.sub_tit {
		background: #f6f7f8;
		border-radius: 8px 8px 0 0;
		padding: 12px 8px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.sub_tit_th {
			text-align: right;
			width: 22%;
		}
		.sub_tit_th1 {
			width: 54%;
			text-align: left;
		}
	}
	.sub_item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 8px;
		border-bottom: 1rpx solid #e5e7ed;
		font-size: 13px;
		color: #919398;
		.sub_td {
			text-align: right;
			width: 22%;
		}
		.sub_td1 {
			width: 54%;
			text-align: left;
		}
	}
	.sub_item:last-child {
		border-bottom: none;
	}
}
</style>



// WEBPACK FOOTER //
// packages/appletView/src/pages/consultations/consultations-detail.vue